<template>
  <div class="yxtbiz-medal-dialog">
    <yxtf-dialog
      :visible.sync="dialogVisible"
      width="640px"
      :cutline="false"
      :show-close="false"
    >
      <div class="yxtbiz-medaldetail-headercontainer">
        <yxtf-portrait
          size="120px" 
          :username="userName"
          :imgUrl="userLogoUrl"
          class="yxtbiz-medaldetail-headercontainer_logo"
        ></yxtf-portrait>
        <div class="yxtbiz-medaldetail-headercontainer_namebox">
          <div class="yxtbiz-medaldetail-headercontainer_name"><yxtbiz-user-name :name="userName" /></div>
          <div class="yxtbiz-medaldetail-headercontainer_count">{{formatCount}}</div>
        </div>        
        <yxtf-svg
          class="yxtbiz-medaldetail-headercontainer_infobg"
          :remote-url="mediaPath"
          width="271px"
          height="160px"
          icon-class="medal-biz-infobg"
        />
        <div
          @click="dialogVisible = false"
        >
          <yxtf-svg
            class="yxtbiz-medaldetail-headercontainer_close hand"
            :remote-url="mediaPath"
            width="24px"
            height="24px"
            icon-class="close"
          />
        </div>
      </div>
      <div class="yxtbiz-medaldetail-tablecontainer">
        <yxtf-scrollbar :fit-height="true">
          <medal-box v-for="item in gridData" :myContinueDays="myContinueDays" :isSelf="isSelf" :key="item.id" :data="item" />
        </yxtf-scrollbar>
      </div>
    </yxtf-dialog>
  </div>
</template>
<script>
import medalBox from './medalBox';
import { getMedalDetailList, getHourContinuityDays } from '../service';
export default {
  components: {
    medalBox
  },
  data() {
    return {
      mediaPath: `${this.$staticBaseUrl}ufd/407a24/reward/pc/svg`,
      gridData: [],
      dialogVisible: false,
      orgId: '',
      userId: '',
      userLogoUrl: '',
      userName: '',
      myContinueDays: 0,
      medalCount: 0,
      isSelf: false
    };
  },
  computed: {
    formatCount() {
      let count = this.medalCount > 99 ? '99+' : this.medalCount;
      return this.$t('pc_biz_medal_lbl_getmedalcount', {0: count});
    }
  },
  methods: {
    show(orgId, userId, userLogoUrl, userName, count, isSelf) {
      this.orgId = orgId;
      this.userId = userId;
      this.userLogoUrl = userLogoUrl;
      this.userName = userName;
      this.medalCount = count;
      this.isSelf = isSelf;
      this.getMedalDetailListData();
      if (isSelf) {
        this.getHourContinuityDays();
      }
      this.dialogVisible = true;
    },
    getMedalDetailListData() {
      getMedalDetailList(this.orgId, this.userId).then(res=>{
        this.gridData = res;
      });
    },
    getHourContinuityDays() {
      getHourContinuityDays(365, this.userId).then(res=>{
        this.myContinueDays = res.myContinueDays;
      });
    }
  }
};
</script>
